import React, {useState} from 'react';
import './style.scss';

const Modal = ({ show, onClose, children }) => {
  if (!show) {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    return null;
  }
  document.getElementsByTagName('body')[0].classList.add('modal-open');
  return (
    <div className="modal-overlay"
        onClick={(e)=>{
            if(e.target.className === 'modal-overlay' && onClose){
                onClose()
            }
        }}>
      <div className="modal-content">
        {children}
      </div>
    </div>
  );
};

export default Modal;
